import { render, staticRenderFns } from "./WebsiteInterface.vue?vue&type=template&id=065f9aa2&scoped=true&"
import script from "./WebsiteInterface.vue?vue&type=script&lang=js&"
export * from "./WebsiteInterface.vue?vue&type=script&lang=js&"
import style0 from "./WebsiteInterface.css?vue&type=style&index=0&id=065f9aa2&prod&scoped=true&lang=css&"
import style1 from "./WebsiteInterfaceUnScoped.css?vue&type=style&index=1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065f9aa2",
  null
  
)

export default component.exports